import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import { Card, CardContent, Grid, Typography, useTheme } from "@mui/material";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import { useEffect, useState } from "react";
import HeaderCustom from "../../components/header/HeaderCustom";
import { tokens } from "../../theme";
import { apiUrl } from '../../constants'
import axios from 'axios'
import moment from 'moment-timezone';
import { useParams } from 'react-router-dom';
import db from "../../firebase-config"

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#bcd6d0",
  padding: theme.spacing(0),
  textAlign: "center",
}));
const GridDashed = styled(Grid)(({ }) => ({
  "&:not(:last-child)": {
    borderRight: "2px dashed #000",
  },
  padding: "2px 0",
}));
const CardItem = styled(Card)(({ }) => ({
  background: "#8ad4c1",
  "&.second": { background: "#e2efec" },
  height: 360
}));
const TypographyCardHeader = styled(Typography)(({ colors }) => ({
  color: colors.neutral["black"],
  fontWeight: "bold",
  fontSize: 46,
  lineHeight: "9vh",
}));
const BarCardHeader = styled("div")(({ colors }) => ({
  width: "100%",
  borderRadius: "0 0 4px 4px",
  background: colors.neutral["green"],
  "&.second": { background: "#bdd7d0" },
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "3px 10px",
}));
const ChipStyled = styled("Div")(({ colors }) => ({
  background: "#8ad4c1",
  "&.second": { background: "#e2efec" },
  padding: "2px 5px",
  color: colors.neutral["black"],
  fontWeight: "bold",
  fontSize: 46,
  "& :last-child": {
    fontSize: "16px",
    fontWeight: "normal",
    marginBottom: "-5px",
  },
  "& :first-child": { marginBottom: "-5px" },
  lineHeight: "23px",
  minHeight: "60px",
  borderRadius: "4px",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
  minWidth: "70px",
}));
const CardContentStyled = styled(Grid)(({ }) => ({
  fontSize: "40px",
  "& :last-child": {
    fontWeight: "bold",
  },
  lineHeight: "60px",
  textAlign: "left"
}));

const ProductionChickenP1 = () => {
  const { bu, plant, factory, line } = useParams();
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 2);
  yesterday.setHours(0, 0, 0, 0);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [shift, setShift] = useState({});

  const [chickenYard, setChickenYard] = useState([]);
  const [chickenYardHistory, setChickenYardHistory] = useState([]);
  const [noData, setNoData] = useState(false);
  const [tagList, setTagList] = useState([]);

  const get_api = () => {
    try {
      const buName = bu;
      const plantName = plant;
      const factoryName = factory;
      const lineName = line;

      const apiMapping = {
        "แปรรูปไก่_4070_SLHKorat_Line1": apiUrl.CHECKEN_YARD_LINE1,
        "แปรรูปไก่_4070_SLHKorat_Line2": apiUrl.CHECKEN_YARD_LINE2,
      };

      const key = `${buName}_${plantName}_${factoryName}_${lineName}`;

      return apiMapping[key];
    } catch (error) {
      console.error("Error in chicken yard:", error);
      return null;
    }
  };


  useEffect(() => {
    function updateShift() {
      const now = new Date();
      const hour = now.getHours();

      if (hour >= 3 && hour < 16) {
        // 03:00 - 15:59 → กลางวัน
        setShift({ SHIFT: "D" });
      } else {
        // 16:00 - 02:59 → กลางคืน
        setShift({ SHIFT: "N" });
      }
    }

    updateShift(); // เรียกครั้งแรกตอน mount

    const timer = setInterval(updateShift, 60 * 1000); // อัพเดททุก 1 นาที
    return () => clearInterval(timer); // clear ตอน unmount
  }, []);

  useEffect(() => {
    const subscriberTagList = db
      .collection("prod_mes_ignition_slaughter_airchill_tag_list")
      .onSnapshot((querySnapshot) => {
        const tagListData = querySnapshot.docs.map(doc => ({
          ...doc.data(),
          id: doc.id,
        }));
        setTagList(tagListData);
      });
    return () => {
      subscriberTagList();
    }
  }, []);


  useEffect(() => {
    async function fetchMyAPI() {
      try {
        const response = await axios.get(`${get_api()}`, {
          headers: {
            authorizationToken: "lFao}A!iCSg3v'sT{=*p*irT2f@#.X(9.1B:M9R'z*Qy=y\\F--Jme7EAQ){-A2x)",
          },
        });
  
        if (response.status === 200) {
          setChickenYard(response.data);
          sessionStorage.setItem("chickenYard", JSON.stringify(response.data));
          setNoData(1);
        }
      } catch (error) {
        setNoData(2);
        console.log("error:", error);
      }
    }
  
    fetchMyAPI();
  
    const interval = setInterval(fetchMyAPI, 1 * 60 * 1000);
  
    return () => clearInterval(interval);
  }, []);
  

  useEffect(() => {
    const storedCheckenYard = sessionStorage.getItem("chickenYard");
    if (storedCheckenYard) setChickenYardHistory(JSON.parse(storedCheckenYard));
  }, []);

  const findTAG = (key) => (tagList || []).find((a) => (a?.TAG || "").includes(key)) || null;

  const truckStartTime = findTAG(`SLH_Korat.4070.00000000000000.Thailand.Chicken_Counter.HangingArea.${line}.TruckStartTime`);



  return (
    <>
      <Grid container justifyContent={"center"}>
        <Grid item xs={12}>
          <HeaderCustom
            icon={
              shift?.SHIFT === "N" ? (
                <Tooltip title="กะ Night" arrow>
                  <DarkModeOutlinedIcon style={{ color: "#ffffff" }} />
                </Tooltip>
              ) : (
                <Tooltip title="กะ Day" arrow>
                  <LightModeOutlinedIcon style={{ color: "#ffffff" }} />
                </Tooltip>
              )
            }
          >
            ลานไก่เป็น {line}
          </HeaderCustom>
        </Grid>
        <Grid item xs={12} style={{ padding: 8 }}>
          <Item>
            <Grid
              container
              rowSpacing={0}
              columnSpacing={{ xs: 0, sm: 0, md: 0 }}
              p={0.5}
            >
              <GridDashed item xs={3}>
                <Typography
                  style={{
                    color: colors.neutral["black"],
                    fontWeight: "bold",
                    fontSize: 46,
                    lineHeight: "9vh",
                  }}
                >
                  แผนเข้าโรงงาน
                </Typography>
                <Typography
                  style={{
                    color: colors.neutral["black"],
                    fontWeight: "bold",
                    fontSize: 60,
                    lineHeight: "8vh",
                  }}
                >
                  {noData === 1 ? (chickenYard?.plan?.totalPlan ?? chickenYardHistory?.plan?.totalPlan ?? '-') : '-'} คัน
                </Typography>
              </GridDashed>

              <GridDashed item xs={3}>
                <Typography
                  style={{
                    color: colors.neutral["black"],
                    fontWeight: "bold",
                    fontSize: 46,
                    lineHeight: "9vh",
                  }}
                >
                  เข้าโรงงาน
                </Typography>
                <Typography
                  style={{
                    color: colors.complementary.gold["800"],
                    fontWeight: "bold",
                    fontSize: 60,
                    lineHeight: "8vh",
                  }}
                >
                  {noData === 1 ? (chickenYard?.arrived_count?.numberOfArrived ?? chickenYardHistory?.arrived_count?.numberOfArrived ?? '-') : '-'} คัน
                </Typography>
              </GridDashed>
              <GridDashed item xs={3}>
                <Typography
                  style={{
                    color: colors.neutral["black"],
                    fontWeight: "bold",
                    fontSize: 46,
                    lineHeight: "9vh",
                  }}
                >
                  แขวนเสร็จสิ้น
                </Typography>
                <Typography
                  style={{
                    color: colors.neutral["green"],
                    fontWeight: "bold",
                    fontSize: 60,
                    lineHeight: "8vh",
                  }}
                >
                  {noData === 1 ? (chickenYard?.recieved_count?.numberOfReceived ?? chickenYardHistory?.recieved_count?.numberOfReceived ?? '-') : '-'} คัน
                </Typography>
              </GridDashed>
              <GridDashed item xs={3}>
                <Typography
                  style={{
                    color: colors.neutral["black"],
                    fontWeight: "bold",
                    fontSize: 46,
                    lineHeight: "9vh",
                  }}
                >
                  เดินทาง
                </Typography>
                <Typography
                  style={{
                    color: "red",
                    fontWeight: "bold",
                    fontSize: 60,
                    lineHeight: "8vh",
                  }}
                >
                  {noData === 1 ? (chickenYard?.entering_count?.numberOfEnteringTheFactory ?? chickenYardHistory?.entering_count?.numberOfEnteringTheFactory ?? '-') : '-'} คัน
                </Typography>
              </GridDashed>
            </Grid>
          </Item>
        </Grid>
        <Grid item xs={12} pl={"8px"} pr={"8px"} container spacing={1}>
          <Grid item xs={6}>
            <CardItem className="next">
              <BarCardHeader
                className="next"
                colors={colors}
              >
                <ChipStyled
                  className="next"
                  colors={colors}
                >
                  Loading
                </ChipStyled>
                <TypographyCardHeader colors={colors}>
                  คิวที่ {noData === 1 ? (chickenYard?.current_queue_live_bird?.IsComplete === true ? (chickenYard?.current_queue_live_bird?.Data?.QUEUE_NO === undefined ? (chickenYardHistory?.current_queue_live_bird?.Data?.QUEUE_NO === undefined ? '-' : chickenYardHistory?.current_queue_live_bird?.Data?.QUEUE_NO === null ? 'NA' : chickenYardHistory?.current_queue_live_bird?.Data?.QUEUE_NO) : chickenYard?.current_queue_live_bird?.Data?.QUEUE_NO === null ? 'NA' : chickenYard?.current_queue_live_bird?.Data?.QUEUE_NO) : '-') : '-'}
                </TypographyCardHeader>
                <ChipStyled
                  className="next"
                  colors={colors}
                >
                  <Grid item xs={12} style={{ fontSize: 36 }}>
                    {noData === 1 ? (chickenYard?.current_queue_live_bird?.IsComplete === true ? (chickenYard?.current_queue_live_bird?.Data?.LOT_NO === undefined ? (chickenYardHistory?.current_queue_live_bird?.Data?.LOT_NO === undefined ? '-' : chickenYardHistory?.current_queue_live_bird?.Data?.LOT_NO === null ? 'NA' : chickenYardHistory?.current_queue_live_bird?.Data?.LOT_NO) : chickenYard?.current_queue_live_bird?.Data?.LOT_NO === null ? 'NA' : chickenYard?.current_queue_live_bird?.Data?.LOT_NO) : '-') : '-'}
                    -
                    {noData === 1 ? (chickenYard?.current_queue_live_bird?.IsComplete === true ? (chickenYard?.current_queue_live_bird?.Data?.SUBLOT === undefined ? (chickenYardHistory?.current_queue_live_bird?.Data?.SUBLOT === undefined ? '-' : chickenYardHistory?.current_queue_live_bird?.Data?.SUBLOT === null ? 'NA' : chickenYardHistory?.current_queue_live_bird?.Data?.SUBLOT) : chickenYard?.current_queue_live_bird?.Data?.SUBLOT === null ? 'NA' : chickenYard?.current_queue_live_bird?.Data?.SUBLOT) : '-') : '-'}
                  </Grid>
                  <Grid
                    className="next"
                    item
                    xs={12}
                    style={{ fontSize: 24, paddingTop: 10}}
                  >
                    lot - Sublot
                  </Grid>
                </ChipStyled>
              </BarCardHeader>
              <CardContent sx={{ padding: "20px 20px" }}>
                <Grid container item xs={12}>
                  <CardContentStyled container item xs={7}>
                    <Grid item xs={4} >
                      ทะเบียน
                    </Grid>
                    <Grid item xs={8}>
                      {noData === 1 ? (chickenYard?.current_loading_queue?.licensePlate ?? chickenYardHistory?.current_loading_queue?.licensePlate ?? '-') : '-'}
                    </Grid>
                  </CardContentStyled>
                  <CardContentStyled container item xs={5}>
                    <Grid item xs={5} >
                      จำนวน
                    </Grid>
                    <Grid item xs={7}>
                      {
                        noData === 1
                          ? (
                            chickenYard?.current_loading_queue?.quantity != null
                              ? chickenYard.current_loading_queue.quantity.toLocaleString()
                              : chickenYardHistory?.current_loading_queue?.quantity != null
                                ? chickenYardHistory.current_loading_queue.quantity.toLocaleString()
                                : '-'
                          )
                          : '-'
                      } ตัว                   
                    </Grid>
                  </CardContentStyled>
                  <CardContentStyled container item xs={7}>
                    <Grid item xs={4}>
                      ฟาร์ม
                    </Grid>
                    <Grid item xs={8}>
                    {noData === 1 ? (chickenYard?.current_loading_queue?.house ?? chickenYardHistory?.current_loading_queue?.house ?? '-') : '-'}
                    </Grid>
                  </CardContentStyled>
                  <CardContentStyled container item xs={5}>
                    <Grid item xs={6}>
                      น้ำหนัก
                    </Grid>
                    <Grid item xs={6}>
                    {noData === 1 ? (chickenYard?.current_loading_queue?.weight ?? chickenYardHistory?.current_loading_queue?.weight ?? '-') : '-'} kg
                    </Grid>
                  </CardContentStyled>
                  <CardContentStyled container item xs={7}>
                    <Grid item xs={4}>
                      เวลาคิว
                    </Grid>
                    <Grid item xs={8}>
                    {
                        noData === 1
                          ? (
                            chickenYard?.current_loading_queue?.queueTime != null
                              ? moment(chickenYard.current_loading_queue.queueTime).format('HH:mm')
                              : chickenYardHistory?.current_loading_queue?.queueTime != null
                                ? moment(chickenYardHistory.current_loading_queue.queueTime).format('HH:mm')
                                : '-'
                          )
                          : '-'
                      }
                    </Grid>
                  </CardContentStyled>
                  <CardContentStyled container item xs={5}>
                    <Grid item xs={6}>
                      เวลาจริง
                    </Grid>
                    <Grid item xs={6}>
                      <span style={{ color: colors.neutral["black"] }}>{truckStartTime?.VALUE === undefined ? 'NA' : moment(truckStartTime?.VALUE, "HH:mm:ss").format("HH:mm:ss")}</span>
                    </Grid>
                  </CardContentStyled>
                </Grid>
              </CardContent>
            </CardItem>
          </Grid>

          <Grid item xs={6}>
            <CardItem className="second">
              <BarCardHeader
                className="second"
                colors={colors}
              >
                <ChipStyled
                  className="second"
                  colors={colors}
                >
                  Next
                </ChipStyled>
                <TypographyCardHeader colors={colors}>
                  คิวที่ {noData === 1 ? (chickenYard?.next_queue_live_bird?.IsComplete === true ? (chickenYard?.next_queue_live_bird?.Data?.QUEUE_NO === undefined ? (chickenYardHistory?.next_queue_live_bird?.Data?.QUEUE_NO === undefined ? '-' : chickenYardHistory?.next_queue_live_bird?.Data?.QUEUE_NO === null ? 'NA' : chickenYardHistory?.next_queue_live_bird?.Data?.QUEUE_NO) : chickenYard?.next_queue_live_bird?.Data?.QUEUE_NO === null ? 'NA' : chickenYard?.next_queue_live_bird?.Data?.QUEUE_NO) : '-') : '-'}
                </TypographyCardHeader>
                <ChipStyled
                  className="second"
                  colors={colors}
                >
                  <Grid item xs={12} style={{ fontSize: 36 }}>
                  {noData === 1 ? (chickenYard?.next_queue_live_bird?.IsComplete === true ? (chickenYard?.next_queue_live_bird?.Data?.LOT_NO === undefined ? (chickenYardHistory?.next_queue_live_bird?.Data?.LOT_NO === undefined ? '-' : chickenYardHistory?.next_queue_live_bird?.Data?.LOT_NO === null ? 'NA' : chickenYardHistory?.next_queue_live_bird?.Data?.LOT_NO) : chickenYard?.next_queue_live_bird?.Data?.LOT_NO === null ? 'NA' : chickenYard?.next_queue_live_bird?.Data?.LOT_NO) : '-') : '-'}
                    -
                  {noData === 1 ? (chickenYard?.next_queue_live_bird?.IsComplete === true ? (chickenYard?.next_queue_live_bird?.Data?.SUBLOT === undefined ? (chickenYardHistory?.next_queue_live_bird?.Data?.SUBLOT === undefined ? '-' : chickenYardHistory?.next_queue_live_bird?.Data?.SUBLOT === null ? 'NA' : chickenYardHistory?.next_queue_live_bird?.Data?.SUBLOT) : chickenYard?.next_queue_live_bird?.Data?.SUBLOT === null ? 'NA' : chickenYard?.next_queue_live_bird?.Data?.SUBLOT) : '-') : '-'}
                  </Grid>
                  <Grid
                    className="second"
                    item
                    xs={12}
                    style={{ fontSize: 24, paddingTop: 10 }}
                  >
                    lot - Sublot
                  </Grid>
                </ChipStyled>
              </BarCardHeader>
              <CardContent sx={{ padding: "20px 20px" }}>
                <Grid container item xs={12}>
                  <CardContentStyled container item xs={7}>
                    <Grid item xs={4}>
                      ทะเบียน
                    </Grid>
                    <Grid item xs={8}>
                    {noData === 1 ? (chickenYard?.next_loading_queue?.licensePlate ?? chickenYardHistory?.next_loading_queue?.licensePlate ?? '-') : '-'}
                    </Grid>
                  </CardContentStyled>
                  <CardContentStyled container item xs={5}>
                    <Grid item xs={5}>
                      จำนวน
                    </Grid>
                    <Grid item xs={7}>
                    {
                        noData === 1
                          ? (
                            chickenYard?.next_loading_queue?.quantity != null
                              ? chickenYard.next_loading_queue.quantity.toLocaleString()
                              : chickenYardHistory?.next_loading_queue?.quantity != null
                                ? chickenYardHistory.next_loading_queue.quantity.toLocaleString()
                                : '-'
                          )
                          : '-'
                      } ตัว
                    </Grid>
                  </CardContentStyled>
                  <CardContentStyled container item xs={7}>
                    <Grid item xs={4}>
                      ฟาร์ม
                    </Grid>
                    <Grid item xs={8}>
                    {noData === 1 ? (chickenYard?.next_loading_queue?.house ?? chickenYardHistory?.next_loading_queue?.house ?? '-') : '-'}
                    </Grid>
                  </CardContentStyled>
                  <CardContentStyled container item xs={5}>
                    <Grid item xs={6}>
                      น้ำหนัก
                    </Grid>
                    <Grid item xs={6}>
                    {noData === 1 ? (chickenYard?.next_loading_queue?.weight ?? chickenYardHistory?.next_loading_queue?.weight ?? '-') : '-'} kg
                    </Grid>
                  </CardContentStyled>
                  <CardContentStyled container item xs={7}>
                    <Grid item xs={4}>
                      เวลาคิว
                    </Grid>
                    <Grid item xs={8}>
                    {
                        noData === 1
                          ? (
                            chickenYard?.next_loading_queue?.queueTime != null
                              ? moment(chickenYard.next_loading_queue.queueTime).format('HH:mm')
                              : chickenYardHistory?.next_loading_queue?.queueTime != null
                                ? moment(chickenYardHistory.next_loading_queue.queueTime).format('HH:mm')
                                : '-'
                          )
                          : '-'
                      }
                    </Grid>
                  </CardContentStyled>

                </Grid>
              </CardContent>
            </CardItem>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ProductionChickenP1;
